var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_55",
    "data-name": "Group 55",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.628,
    height: 56,
    viewBox: "0 0 57.628 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "M",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M62.524-343.68l-.009,52.468a.242.242,0,0,1-.274.274H57.586a.242.242,0,0,1-.274-.274V-343.68Z",
    transform: "translate(-48.925 346.938)",
    fill: "var(--theme-text)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M4.747-354.68c1.247,0,1.278,0,1.278,0H17.139a4.69,4.69,0,0,1,5.044,4.672c0,1.14,0,51.054,0,51.054a.242.242,0,0,1-.274.274H17.252a.242.242,0,0,1-.274-.274v-50.891H5.2v50.891a.242.242,0,0,1-.274.274H.274A.242.242,0,0,1,0-298.954s0-46.958,0-50.713A4.813,4.813,0,0,1,4.747-354.68Z",
    transform: "translate(0 354.68)",
    fill: "var(--theme-text)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "G",
    d: "M142.344-354.68h3.012q5.614,0,5.614,5.066v9.037a.242.242,0,0,1-.274.274h-4.655a.242.242,0,0,1-.274-.274v-9.037H141.8v45.868h3.971v-20.4h-1.1a.242.242,0,0,1-.274-.274v-4.655q.034-.274.274-.274H150.7q.274.034.274.274v25.467q0,3.389-2.6,4.518a5.214,5.214,0,0,1-2.191.411h-4.929q-4.655,0-4.655-5.477v-44.91Q136.594-354.68,142.344-354.68Z",
    transform: "translate(-93.342 354.68)",
    fill: "var(--theme-text)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M86.4-354.68h3.56q3.834,0,4.929,2.875a4.518,4.518,0,0,1,.411,1.917v50.934a.242.242,0,0,1-.274.274H90.376a.242.242,0,0,1-.274-.274v-25.193H86.268v25.193a.242.242,0,0,1-.274.274H81.339a.242.242,0,0,1-.274-.274v-50.523a4.8,4.8,0,0,1,3.56-5.066A11.686,11.686,0,0,1,86.4-354.68Zm-.137,5.066v20.264H90.1v-20.264Z",
    transform: "translate(-55.151 354.68)",
    fill: "var(--theme-text)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagLogo);
export default __webpack_public_path__ + "static/media/magLogo.08b19dc0de776058f40692944b7553d8.svg";
export { ForwardRef as ReactComponent };